import React from 'react'
import './Header.css'

export default class Header extends React.Component {
  render(){
    return (
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark sticky-top">
        <a className="navbar-brand" href="#home">#eandrade</a>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
      
        <div className="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
          <ul className="navbar-nav justify-content-end">
            <li className="nav-item active">
              <a className="nav-link" href="#home">Inicio <span className="sr-only">(current)</span></a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#about">Acerca de</a>
            </li>
            {/**<li className="nav-item">
              <a className="nav-link" href="#contact">Contacto</a>
            </li>**/}
          </ul>
        </div>
      </nav>    
    )
  }
}
